import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import DslStore, {
  setPortfolioDesign,
  setUserAwards,
  setUserInspirations,
  setUserInspirationsCopy,
} from '../../../store/DslStore';

import styles from './PopUpSaveDraft.module.scss';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

import axiosHelper from '../../../helpers/axiosHelper';
import { Modal } from 'react-bootstrap';
import { getCurrentDesign, getCurrentUser } from '../../../store/Selectors';
import { useStoreState } from 'pullstate';
import { useNavigate } from 'react-router-dom';

interface PopUpLoginProps {
  popup: boolean;
  close: () => void;
  accept: () => void;
}

const PopUpSaveDraft: React.FC<PopUpLoginProps> = (props) => {
  const currentdesign = useStoreState(DslStore, getCurrentDesign);
  const currentUser = useStoreState(DslStore, getCurrentUser);
  const [popup, setPopup] = useState(props.popup);
  const redirect = useNavigate();

  return (
    <>
      <Modal
        show={props.popup}
        onHide={() => (setPopup(!popup), props.close && props.close())}
        className={`d-flex flex-column justify-content-center `}
        contentClassName={` ${styles.rounded}`}
      >
        <div className={`d-flex flex-column justify-content-center text-center  full bg-light-gray ${styles.rounded}`}>
          <Modal.Body className="d-flex justify-content-center p-3">
            {/* <form onSubmit={handleSubmit(onSubmit)}> */}
            <div className="row justify-content-center align-items-center  ">
              <div className="col-12 mb-3">
                <span className="text-16 fw-bold ">You are saving a draft.</span>
              </div>
              <div className="d-flex col-12 py-4 flex-row align-items-center justify-content-center">
                <p className="text-16">
                  Make sure all fields are correctly filled in before publishing your project. <br /> The sooner you
                  publish your project, the better
                </p>
              </div>

              <div className="d-flex col-12 py-4 flex-row align-items-center justify-content-center">
                <p className="text-16">
                  <i>
                    In case you forget to publish your design, only complete drafts will be automatically submitted for
                    the contest at the end of the upload phase, while incomplete drafts will be discarted
                  </i>
                </p>
              </div>

              <div className="row ">
                <div className="col-12  d-flex justify-content-between ">
                  <div className="col-3 ps-1  d-flex  ">
                    <div className="d-flex justify-content-center align-items-center cursor-pointer">
                      <div
                        className={` ${styles.closeButton}`}
                        onClick={() => {
                          setPopup(!popup);
                          props.close();
                        }}
                      >
                        <FontAwesomeIcon icon={faXmark as IconProp} className=" text color-light " />
                      </div>
                      <span className="ps-3">Close</span>
                    </div>
                  </div>
                  <div className="col-4 pe-1 d-flex   ">
                    <button
                      className={`btn-success rounded full 
                      
                     mb-3`}
                      onClick={() => {
                        console.log('accept');
                        setPopup(!popup);
                        props.accept();
                      }}
                    >
                      Save draft
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* </form> */}
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

export default PopUpSaveDraft;
